<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerText]="(T.GLOBAL_TXT_CONTINUE_SESSION_WITH_COLON | translate) + data?.sessionToBeContinued?.title"
	[headerIcon]="{fontIcon: 'fa-cube', fontSet: 'fad'}"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<sim-scenario-chip-input [scenarioFc]="scenarioFC" label="Scenario" placeholder="Scenario" />
	</ng-container>

	<ng-container actions>
		<button (click)="close({action: 'close'})" color="warn" mat-raised-button style="margin-right: 15px">
			{{ T.BUTTON_CLOSE | translate }}
		</button>

		<button (click)="continueTrainingSession()" [disabled]="scenarioFC.invalid" color="accent" mat-raised-button>
			{{ T.CONTINUE_SESSION_DIALOG_CONTINUE_BTN | translate }}
		</button>
	</ng-container>
</sim-basic-material-dialog>
